export default "__VITE_ASSET__91d9bc2b__"